import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomeView from "./components/HomeView";
import GalleryView from "./components/GalleryView";
import CollectionsView from "./components/CollectionsView";
import CollectionDetailView from "./components/CollectionDetailView";
import NavbarView from "./components/NavbarView";
import NoisePadPrivacyPolicy from "./components/NoisePadPrivacyPolicy";

// The museum pulls in three.js, so it is code-split out of the main bundle and
// only loaded when someone enters an exhibition. The lobby itself is light.
const ExhibitionsView = lazy(() => import("./components/ExhibitionsView"));
const MuseumView = lazy(() => import("./components/MuseumView"));
const ExhibitionMuseumView = lazy(() => import("./components/ExhibitionMuseumView"));
// The admin console (Cognito auth) is code-split out of the public bundle.
const AdminApp = lazy(() => import("./admin/AdminApp"));

function App() {
  return (
    <Router>
      <NavbarView/>
      <Routes>
        <Route path="/" element={<HomeView />} />
        <Route path="/gallery" element={<GalleryView />} />
        <Route path="/gallery/:page" element={<GalleryView />} />
        <Route path="/collections" element={<CollectionsView />} />
        <Route path="/collections/:id" element={<CollectionDetailView />} />
        <Route path="/collections/:id/:page" element={<CollectionDetailView />} />
        <Route
          path="/museum"
          element={
            <Suspense fallback={null}>
              <ExhibitionsView />
            </Suspense>
          }
        />
        <Route
          path="/museum/live"
          element={
            <Suspense fallback={null}>
              <MuseumView />
            </Suspense>
          }
        />
        <Route
          path="/museum/e/:id"
          element={
            <Suspense fallback={null}>
              <ExhibitionMuseumView />
            </Suspense>
          }
        />
        <Route
          path="/museum/preview/:museumId"
          element={
            <Suspense fallback={null}>
              <MuseumView />
            </Suspense>
          }
        />
        <Route
          path="/admin"
          element={
            <Suspense fallback={null}>
              <AdminApp />
            </Suspense>
          }
        />
        <Route path="/NoisePadPrivacyPolicy" element={<NoisePadPrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
